export type ScriptGenerationPhase =
	| 'config'
	| 'generating'
	| 'ready'
	| 'deploying'
	| 'deployed'
	| 'error'

export const scriptGenerationActions = (phase: ScriptGenerationPhase) => ({
	cancel: phase === 'generating' || phase === 'deploying',
	close: phase === 'ready' || phase === 'deployed' || phase === 'error',
	download: phase === 'ready' || phase === 'deployed',
	markDeployed: phase === 'ready',
	showProgress: phase === 'generating' || phase === 'deploying' || phase === 'ready' || phase === 'deployed',
})
